import type { RuntimeActorRole, StudentNoteRecord, StudentNoteVisibility } from './types';

export function canRoleViewNote(role: RuntimeActorRole, note: StudentNoteRecord): boolean {
  if (role === 'superadmin' || role === 'branch_admin' || role === 'teacher') return true;

  if (role === 'guardian') {
    return note.visibility === 'guardian_shared' || note.visibility === 'all_authorized' || note.authorRole === 'guardian';
  }

  if (role === 'student') {
    return note.visibility === 'student_shared' || note.visibility === 'all_authorized';
  }

  return false;
}

export function noteVisibilityOptions(role: RuntimeActorRole): Array<{ value: StudentNoteVisibility; label: string; help: string }> {
  if (role === 'guardian') {
    return [
      { value: 'guardian_shared', label: 'Guru/Admin + orang tua', help: 'Cocok untuk catatan dari rumah yang perlu diketahui tim belajar.' },
      { value: 'all_authorized', label: 'Semua yang berwenang', help: 'Dapat dibaca guru/admin/orang tua dan siswa.' },
    ];
  }

  return [
    { value: 'staff_only', label: 'Internal guru/admin', help: 'Tidak terlihat oleh siswa atau orang tua.' },
    { value: 'guardian_shared', label: 'Bagikan ke orang tua', help: 'Terlihat oleh guru/admin dan orang tua yang terhubung.' },
    { value: 'student_shared', label: 'Bagikan ke siswa', help: 'Terlihat oleh guru/admin dan siswa.' },
    { value: 'all_authorized', label: 'Semua yang berwenang', help: 'Terlihat oleh seluruh pihak yang memiliki akses ke siswa.' },
  ];
}
